<template>
	<div class="palco-page" style="position: relative;">
		<div class="palco-header">
			<div class="container">
				<div class="header-row">
					<div class="header-tipo">
						<span>Palquistas</span>
					</div>
				</div>
				<div class="header-row">
					<div class="header-equipos">
						<div class="header-equipo header-equipo-local">
							<span>Reserva de parking</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="palco-main">
			<div class="container">
				<div class="palco-left" v-if="palco">
					<h1>Palco {{ palco.SectorDescripcion }}</h1>
					<p v-if="Number(palco.PalcoParkingPlazas) <= 0">Tu palco no cuenta con plazas de parking</p>
					<p v-else-if="isDateSetted === true">Completá los datos para la reserva de parking de tu palco</p>
					<p v-else>Ingresa la fecha para la reserva de parking de tu palco</p>
					<div class="elegir-fecha">
						<div class="input-group">
							<label for="date">Fecha de reserva</label>
							<date-picker name="date" id="date" :lang="lang" :format="'DD/MM/YYYY'" v-model="date" placeholder="(Ninguna)" :clearable="false" :editable="false" :disabled="isDateSetted">
								<template v-slot:header="{ emit }">
									<button class="mx-btn mx-btn-text" @click="emit(ayer())">
										Ayer
									</button>
									<button class="mx-btn mx-btn-text" @click="emit(new Date())" >
										Hoy
									</button>
									<button class="mx-btn mx-btn-text" @click="emit(manana())">
										Mañana
									</button>
								</template>
							</date-picker>
						</div>
						<button @click.prevent="elegirFecha()" v-if="isDateSetted === false">Confirmar</button>
					</div>
					<div class="parking-card" v-for="t in ticketsParking" :key="t.ticketNum">
						<div class="parking-card-top">
							<div class="parking-card-left">
								<span class="parking-numero">#{{ t.ticketNum }}</span>
							</div>
							<div class="parking-text">
								Ingrese la matrícula y los datos del conductor que hará uso de la plaza disponible de tu palco.
							</div>
						</div>
						<div class="parking-card-main">
							<div class="parking-input">
								<label :for="'ticket-nombre-' + t.ticketNum">Nombre</label>
								<input type="text" name="ticket-nombre" :id="'ticket-nombre-' + t.ticketNum" v-model="t.nombre">
							</div>
							<div class="parking-input">
								<label :for="'ticket-apellido-' + t.ticketNum">Apellido</label>
								<input type="text" name="ticket-apellido" :id="'ticket-apellido-' + t.ticketNum" v-model="t.apellido">
							</div>
							<div class="parking-input">
								<label :for="'ticket-telefono-' + t.ticketNum">Teléfono</label>
								<input type="text" name="ticket-telefono" :id="'ticket-telefono-' + t.ticketNum" v-model="t.telefono" @keypress="soloNumeros">
							</div>
							<div class="parking-input">
								<label :for="'ticket-matricula-' + t.ticketNum">Matrícula</label>
								<input type="text" name="ticket-matricula" :id="'ticket-matricula-' + t.ticketNum" v-model="t.matricula" maxlength="10" @keydown="checkKeyDownAlphaNumeric($event)" @paste.prevent>
							</div>
						</div>
					</div>
					<div class="tickets-canjear" v-if="SDTPalcoReservaFecha && Number(SDTPalcoReservaFecha.CantDisponibles) > 0 && isDateSetted === true">
						<button class="btn" @click="canjearParking">Reservar parking</button>
					</div>
					<div v-if="SDTPalcoReservaFecha && Number(SDTPalcoReservaFecha.CantDisponibles) === 0 && isDateSetted === true">
						<p>Tu palco no tiene plazas de parking restantes para la fecha seleccionada</p>
					</div>
					<div class="parking-emitidos" v-if="SDTPalcoReservaFecha && SDTPalcoReservaFecha.Reserva.length > 0">
						<p>Reservas ya realizadas</p>
						<div class="parking-card-ticket" v-for="parking in SDTPalcoReservaFecha.Reserva" :key="parking.PalcoReservaId">
							<div class="parking-card-left">
								<span class="parking-numero">#{{ parking.PalcoReservaId }}</span>
							</div>
							<div class="parking-card-right">
								<div class="row">
									<div class="ticket-group">
										<span class="label">Matrícula</span>
										<span class="valor matricula">{{ parking.PalcoReservaMatricula }}</span>
									</div>
								</div>
								<div class="row">
									<div class="ticket-group">
										<span class="label">Teléfono</span>
										<span class="valor matricula">{{ parking.PalcoReservaNombre }}</span>
									</div>
									<div class="ticket-group">
										<span class="label">Nombre</span>
										<span class="valor">{{ parking.PalcoReservaNombre }} {{ parking.PalcoReservaApellido }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="palco-right">
					<div class="palco-right-content">
						<div class="descripcion">
							<span class="descripcion-title">Información</span>
							<div class="espectaculo-descripcion">
								Cada día podrás reservar en el parking del Gran Parque Central tantas plazas de parking como tu palco posea. Los días de partido no se permiten reservas. <br><br>
								Una vez realizada la reserva, le llegará un correo electrónico con el ticket al referente del palco.
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import DatePicker from "vue2-datepicker";

	export default {
		data(){
			return {
				isDateSetted: false,
				date: new Date(),
				palco: null,
				SDTPalcoReservaFecha: null,
				
				/* Parking */
				ticketsParking: [],

				/* Datepicker */
				lang: {
					formatLocale: {
						months: [
							"Enero",
							"Febrero",
							"Marzo",
							"Abril",
							"Mayo",
							"Junio",
							"Julio",
							"Agosto",
							"Setiembre",
							"Octubre",
							"Noviembre",
							"Diciembre",
						],
						monthsShort: [
							"Ene",
							"Feb",
							"Mar",
							"Abr",
							"May",
							"Jun",
							"Jul",
							"Ago",
							"Set",
							"Oct",
							"Nov",
							"Dic",
						],
						weekdays: [
							"Domingo",
							"Lunes",
							"Martes",
							"Miércoles",
							"Jueves",
							"Viernes",
							"Sábado",
						],
						weekdaysShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
						weekdaysMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
					},
				}
			}
		},
		components: {
			DatePicker
		},
		async mounted(){
			this.$store.dispatch('cargando', true);
			this.isDateSetted = false;
			await this.validarPalco();
			this.$store.dispatch('cargando', false);
		},
		methods: {
			soloNumeros ($event) {
				let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
				if (keyCode < 48 || keyCode > 57) {
					$event.preventDefault();
				}
			},
			checkKeyDownAlphaNumeric(event) {
				if (!/[a-zA-Z0-9]+/.test(event.key)) {
					event.preventDefault();
				}
			},
			async validarPalco(){
				// Valido palco
				try{
					let response = await axios.post('/WSPalquistaReservaValidar', {
						TribunaId: Number(this.$route.params.tribunaId),
						SectorCod: this.$route.params.sectorCod,
						Token: this.$route.params.palcoToken },
					{});

					if(response.data.ErrorCod === 0){
						this.palco = response.data.SDTPalcoReserva;
					} else {
						this.$router.push({ name: 'error' });
					}
				} catch (error){
					this.$router.push({ name: 'error' });
				}
			},
			async canjearParking(){
				let todosVacios = true
				for(let v=0; v < this.ticketsParking.length; v++){
					if(this.ticketsParking[v].matricula.trim() || this.ticketsParking[v].nombre.trim() || this.ticketsParking[v].apellido.trim() || this.ticketsParking[v].telefono.trim()){
						todosVacios = false
						break;
					}
				}

				let hayRepetidos = false

				if(todosVacios === true){
					this.$store.dispatch('mostrarError', 'Todos los datos están vacíos')
				} else {
					let auxSDTPalcoReservaFecha = {
						PalcoReservaFecha: this.date,
						TribunaId: Number(this.$route.params.tribunaId),
						SectorCod: this.$route.params.sectorCod,
						Reserva: []
					}

					let hayError = false;
					for(let m=0; m<this.ticketsParking.length; m++){
						if(this.ticketsParking[m].matricula.trim() || this.ticketsParking[m].nombre.trim() || this.ticketsParking[m].apellido.trim() || this.ticketsParking[m].telefono.trim()){
							if(this.ticketsParking[m].matricula.trim() && this.ticketsParking[m].nombre.trim() && this.ticketsParking[m].apellido.trim() && this.ticketsParking[m].telefono.trim()){
								if(this.ticketsParking[m].matricula.length > 4 && this.ticketsParking[m].matricula.length < 11){
									for(let k=0; k<this.ticketsParking.length; k++){
										if(k !== m){
											if(this.ticketsParking[m].matricula && this.ticketsParking[m].matricula === this.ticketsParking[k].matricula){
												hayRepetidos = true;
												break;
											}
										}
									}

									if(hayRepetidos === true){
										hayError = true
										this.$store.dispatch('mostrarError', 'Hay matrículas repetidas')
										break;
									} else {
										if(this.ticketsParking[m].telefono.length < 8 || this.ticketsParking[m].telefono.length > 20){
											hayError = true
											this.$store.dispatch('mostrarError', 'Ticket #' + this.ticketsParking[m].ticketNum + ' - Teléfono incorrecto')
											break;
										} else {
											if(hayError === true){
												break;
											}

											let itemTicket = {
												Num: Number(this.ticketsParking[m].ticketNum),
												PalcoReservaMatricula: this.ticketsParking[m].matricula.trim(),
												PalcoReservaNombre: this.ticketsParking[m].nombre.trim(),
												PalcoReservaApellido: this.ticketsParking[m].apellido.trim(),
												PalcoReservaTelefono: this.ticketsParking[m].telefono.trim()
											}

											auxSDTPalcoReservaFecha.Reserva.push(itemTicket);
										}
									}
								} else {
									hayError = true
									this.$store.dispatch('mostrarError', 'Matrícula incorrecta para el ticket #' + this.ticketsParking[m].ticketNum)
									break;
								}
							} else {
								hayError = true
								this.$store.dispatch('mostrarError', 'Debes ingresar todos los datos para el ticket #' + this.ticketsParking[m].ticketNum)
							}
						}
					}

					if(hayError === false){
						this.$store.dispatch('cargando', true);

						// Canjeo tickets de parking
						try{
							let response = await axios.post('/WSPalquistaReservaTicket', { 
								Token: this.$route.params.palcoToken, SDTPalcoReservaFecha: auxSDTPalcoReservaFecha })

							if(response.data.ErrorCod === 0){
								this.$store.dispatch('mostrarSuccess', 'Tickets emitidos correctamente')
								await this.elegirFecha();
								this.$store.dispatch('cargando', false);
							} else {
								if(response.data.ErrorCod === 20 || 
								response.data.ErrorCod === 21 || 
								response.data.ErrorCod === 30 || 
								response.data.ErrorCod === 31 || 
								response.data.ErrorCod === 60 || 
								response.data.ErrorCod === 33 || 
								response.data.ErrorCod === 40 || 
								response.data.ErrorCod === 34){
									this.$store.dispatch('mostrarError', 'Ocurrió un error')
									this.$router.push({ name: 'error' });
								} else {
									this.$store.dispatch('mostrarError', response.data.ErrorDsc)
									this.$store.dispatch('cargando', false);
								}
							}
						} catch(error){
							console.log(error);
							this.$store.dispatch('mostrarError', 'Ocurrió un error')
							this.$store.dispatch('cargando', false);
						}
					}
				}
			},
			async elegirFecha(){
				try {
					this.isDateSetted = false;
					this.SDTPalcoReservaFecha = null

					let response = await axios.post('/WSPalquistaReservaValidarFecha', {
						TribunaId: Number(this.$route.params.tribunaId),
						SectorCod: this.$route.params.sectorCod,
						Token: this.$route.params.palcoToken,
						PalcoReservaFecha: this.date
					},
					{});

					if(response.data.ErrorCod === 0){
						this.isDateSetted = true
						this.SDTPalcoReservaFecha = response.data.SDTPalcoReservaFecha

						this.ticketsParking = [];
						if(Number(this.SDTPalcoReservaFecha.CantDisponibles) > 0){
							for(let i = 0; i<Number(this.SDTPalcoReservaFecha.CantDisponibles); i++){
								let ticketParking = {
									ticketNum: i + 1,
									matricula: '',
									nombre: '',
									apellido: '',
									telefono: ''
								}

								this.ticketsParking.push(ticketParking);
							}
						}
					} else {
						if(response.data.ErrorCod === 10 || response.data.ErrorCod === 70 || response.data.ErrorCod === 71){
							this.$store.dispatch('mostrarError', response.data.ErrorDsc)
						} else {
							console.log('Ocurrió un error al elegir la fecha');
							this.$router.push({ name: 'error' });
						}
					}
				} catch (error) {
					console.log('Ocurrió un error al elegir la fecha');
					this.$router.push({ name: 'error' });
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.palco-page{
		min-height: var(--height-page);
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;
		@include flex(column, flex-start, center);

		.palco-header{
			padding-top: 76px;
			width: 100%;
			position: relative;
			height: 310px;
			background: url('../../assets/sports-player-background.jpg');
			background-position: center center;
			background-size: cover;
			background-repeat: no-repeat;
			@include flex(column, flex-start, center);

			.container{
				height: 100%;
				margin: 0;
				width: 100%;
				@include flex(column, flex-end, center);

				max-width: 1166px;
				padding: 0px 16px;
				z-index: 1;
				padding-bottom: 10px;
				@include flex(column, flex-end, flex-start);
			}

			.header-row{
				width: 100%;
				margin: 5px 0;
				@include flex(row, flex-start, center);

				.header-tipo{
					margin: 0;
					padding: 0;
					
					span{
						border-radius: 4px;
						background-color: var(--color-red);
						color: #fff;
						font-size: 11px;
						line-height: 1em;
						padding: 3px 7px;
						text-transform: uppercase;
						font-family: var(--font-family-poppins);
						letter-spacing: 0.5px;
					}
				}

				.header-equipos{
					margin: 5px 0 15px 0;
					padding: 0;
					position: relative;
					@include flex(column, center, flex-start);

					.header-equipo{
						@include flex(flex, flex-start, center);

						span{
							// font-family: 'Staatliches', cursive;
							line-height: 1.1em;
							color: var(--color-white);
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							text-transform: uppercase;
						}

						&.header-equipo-local{

							span{
								font-size: 32px;

								&.vs{
									font-family: var(--font-family-poppins);
									line-height: 1em;
									color: var(--color-blue-light);
									font-size: 24px;
									margin-left: 10px;
									margin-top: 6px;
									font-weight: var(--font-weight-bold);
								}
							}

							.header-escudo{
								height: 39px;
								width: auto;
								margin-right: 10px;
							}
						}

						&.header-equipo-visitante{
							margin-top: 5px;
							
							span{
								font-size: 30px;
							}

							.header-escudo{
								height: 34px;
								width: auto;
								margin-right: 10px;
								margin-left: 3px;
							}
						}
					}
				}
			}
		}

		.palco-main{
			width: 100%;
			position: relative;
			margin: 64px 0;
			@include flex(row, space-between, flex-start);
			
			.container{
				width: 100%;
				max-width: 1166px;
				padding: 0px 16px;
				@include flex(row, space-between, flex-start);

				.palco-right{
					top: 102px;
					position: sticky;
					margin-top: 41px;
					width: calc(33.33% - 16px);

					p{
						margin: 0;
						font-size: 18px;
						line-height: 26px;
						font-family: var(--font-family-fira);
						font-weight: bold;
						color: var(--color-dark);
						margin-bottom: 18px;
					}

					.palco-right-content{
						border-radius: 8px;
						border: 1px solid #d3d3dc;
						@include flex(column, flex-start, flex-start);

						.competencia{
							border-radius: 0px;
							border: none;
							padding: 20px;
							border-bottom: 1px solid #d3d3dc;
							width: 100%;
							@include flex(row, space-between, center);

							.competencia-info{
								@include flex(column, center, flex-start);

								span.competencia-nombre{
									margin: 0;
									font-size: 13px;
									line-height: 20px;
									margin-bottom: 0px;
									font-weight: var(--font-weight-bold);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									color: var(--color-dark);
									font-family: var(--font-family-poppins);
									text-transform: uppercase;
								}

								span.competencia-instancia{
									color: var(--color-dark);
									font-family: var(--font-family-fira);
									font-weight: var(--font-weight-regular);
									font-size: 15px;
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									line-height: 20px;
								}
							}

							img{
								height: 32px;
								width: auto;
								margin-left: 15px;
							}
						}

						.fecha{
							border-radius: 0px;
							border: none;
							padding: 20px;
							border-bottom: 1px solid #d3d3dc;
							width: 100%;
							@include flex(column, flex-start, flex-start);

							.fecha-title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 2px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							.fecha-content{
								width: 100%;
								@include flex(row, space-between, center);

								.fecha-texto{
									@include flex(column, center, flex-start);

									p{
										color: var(--color-dark);
										font-family: var(--font-family-fira);
										font-weight: var(--font-weight-regular);
										font-size: 15px;
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										line-height: 20px;
										margin: 0;
									}
								}

								.fecha-hora{
									height: 100%;
									margin-left: 14px;
									border-left: 1px solid #d3d3dc;
									padding: 10px 0 10px 14px;
									color: var(--color-dark);
									font-family: var(--font-family-fira);
									font-weight: var(--font-weight-regular);
									font-size: 21px;
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									line-height: 20px;
								}
							}
						}

						.lugar{
							border-radius: 0px;
							border: none;
							padding: 20px;
							border-bottom: 1px solid #d3d3dc;
							width: 100%;
							@include flex(column, flex-start, flex-start);

							.lugar-title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 2px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							.lugar-content{
								@include flex(row, space-between, center);
								width: 100%;

								.lugar-content-left{
									@include flex(row, flex-start, center);

									.lugar-info{
										padding-right: 12px;
										// border-right: 1px solid #d3d3dc;
										@include flex(column, center, flex-start);

										span.lugar-escenario{
											color: var(--color-dark);
											font-family: var(--font-family-fira);
											font-weight: var(--font-weight-regular);
											font-size: 15px;
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											line-height: 20px;
										}

										span.lugar-direccion{
											color: var(--color-dark);
											font-family: var(--font-family-fira);
											font-weight: var(--font-weight-regular);
											font-size: 13px;
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											line-height: 18px;
										}
									}

									img{
										width: 28px;
										height: auto;
										margin-left: 12px;
									}
								}

								.ver-mapa{
									@include flex(column, center, center);
									margin-left: 12px;

									a{
										background-color: transparent;
										border: 1px solid var(--color-blue-darker);
										padding: 6px;
										text-decoration: none;
										@include flex(row, center, center);
										transition: all .2s;
										border-radius: 99px;

										svg{
											width: 15px;
											height: auto;
											transition: all .2s;
											color: var(--color-blue-darker);
										}

										&:hover{
											background-color: var(--color-blue-darker);

											svg{
												color: var(--color-white);
											}
										}
									}
								}
							}
						}

						.descripcion{
							border-radius: 0px;
							border: none;
							padding: 20px;
							width: 100%;
							@include flex(column, flex-start, flex-start);
							
							.descripcion-title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 2px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							.descripcion-content{
								color: var(--color-dark);
								font-family: var(--font-family-fira);
								font-weight: var(--font-weight-regular);
								font-size: 15px;
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								line-height: 20px;
							}
						}
					}
				}

				.palco-left{
					width: calc(66.66% - 16px);
					background-color: var(--color-white);
					padding: 0px;

					h1{
						margin: 0;
						margin-top: -5px;
						color: var(--color-red);
						font-weight: initial;
						font-size: 48px;
						line-height: 46px;
						font-family: var(--font-family-kapra-bold);
						text-transform: uppercase;
					}

					p{
						margin: 0;
						font-size: 18px;
						line-height: 26px;
						font-family: var(--font-family-fira);
						font-weight: bold;
						color: var(--color-dark);
					}

					.info-palquistas{
						width: 100%;
						@include flex(column, center, flex-start);
						margin: 10px 0px;
						border: 1px dashed var(--color-blue-dark);
						padding: 15px;
						
						.info-palquistas-title{
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							color: var(--color-blue-dark);
							text-transform: uppercase;
							font-size: 14px;
						}

						.info-palquistas-text{
							font-family: var(--font-family-fira);
							color: var(--color-blue-dark);
							font-size: 13px;
							margin-top: 3px;
						}
					}

					.tickets{
						width: 100%;
						margin-top: 20px;
						display: grid;
						grid-template-columns: repeat(1, 1fr);
						grid-row-gap: 25px;

						.ticket{
							border-radius: 0px;
							box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.1);
							width: 100%;
							padding: 20px;
							padding-left: 70px;
							position: relative;
							background-color: var(--color-white);
							@include flex(column, flex-start, flex-start);
							transition: all .2s;

							&:hover{
								&:after{
									opacity: 0.9;
								}

								&:before{
									opacity: 0.9;
								}
							}

							&:after{
								content: 'Invitación';
								position: absolute;
								top: 0px;
								left: 0px;
								width: 50px;
								height: calc(100% - 50px);
								@include flex(row, center, center);
								color: var(--color-white);

								writing-mode:vertical-lr;

								font-family: var(--font-family-poppins);
								text-transform: uppercase;
								-webkit-letter-spacing: 2px;
								-moz-letter-spacing: 2px;
								-ms-letter-spacing: 2px;
								letter-spacing: 2px;
								font-size: 13px;
								background-color: var(--color-blue);
							}

							&:before{
								content: '';
								position: absolute;
								bottom: 0px;
								left: 0px;
								width: 50px;
								height: 50px;
								color: var(--color-white);
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								font-family: var(--font-family-poppins);
								@include flex(row, center, center);
								background-color: var(--color-red);
							}

							&#tn1:before{
								content: '#1';
							}

							&#tn2:before{
								content: '#2';
							}

							&#tn3:before{
								content: '#3';
							}

							&#tn4:before{
								content: '#4';
							}

							&#tn5:before{
								content: '#5';
							}

							&#tn6:before{
								content: '#6';
							}

							&#tn7:before{
								content: '#7';
							}

							&#tn8:before{
								content: '#8';
							}

							&#tn9:before{
								content: '#9';
							}

							&#tn10:before{
								content: '#10';
							}

							&#tn11:before{
								content: '#11';
							}

							&#tn12:before{
								content: '#12';
							}

							&#tn13:before{
								content: '#13';
							}

							&#tn14:before{
								content: '#14';
							}

							&#tn15:before{
								content: '#15';
							}

							&#tn16:before{
								content: '#16';
							}

							&#tn17:before{
								content: '#17';
							}

							&#tn18:before{
								content: '#18';
							}

							&#tn19:before{
								content: '#19';
							}

							&#tn20:before{
								content: '#20';
							}

							&#tn21:before{
								content: '#21';
							}

							&#tn22:before{
								content: '#22';
							}

							&#tn23:before{
								content: '#23';
							}

							&#tn24:before{
								content: '#24';
							}

							&#tn25:before{
								content: '#25';
							}

							&#tn26:before{
								content: '#26';
							}

							&#tn27:before{
								content: '#27';
							}

							&#tn28:before{
								content: '#28';
							}

							&#tn29:before{
								content: '#29';
							}

							&#tn30:before{
								content: '#30';
							}

							.palco-row{
								width: 100%;
								@include flex(row, space-between, center);

								.input-group{
									width: 50%;
									padding: 0px 8px 8px 8px;
									margin: 0;
									@include flex(column, center, flex-start);
									position: relative;

									&:first-child{
										padding-left: 0px;
									}

									&:last-child{
										padding-right: 0px;
									}

									label{
										font-size: 16px;
										font-weight: var(--font-weight-regular);
										color: var(--color-grey);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										line-height: 19px;
										font-family: var(--font-family-fira);
									}

									input{
										font-size: 16px;
										line-height: 25px;
										padding-top: 8px;
										border-bottom: 1px solid var(--color-grey-light);
										display: block;
										width: 100%;
										font-weight: var(--font-weight-bold);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-dark);
										font-family: var(--font-family-poppins);
										text-transform: uppercase;
										padding-top: 8px;
										padding-bottom: 10px;

										&:focus{
											border-color: var(--color-blue);
										}
									}

									.small-text{
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-grey);
										font-family: var(--font-family-fira);
										font-size: 11px;
										line-height: 1.4em;
										padding: 0px 10px;
									}
								}

								.palco-ubicacion{
									margin-top: 10px;
									width: 100%;
									@include flex(row, flex-start, center);

									.palco-ubicacion-item{
										padding: 8px 22px 8px 12px;
										// border: 1px dashed var(--color-grey-medium);
										// background-color: #f3f3f9;
										border-right: 1px dashed var(--color-grey-medium);
										border-radius: 0px;
										@include flex(column, flex-start, flex-start);
										margin-right: 10px;

										&:last-child{
											border-right: none;
										}

										.palco-ubicacion-title{
											font-size: 14px;
											font-weight: var(--font-weight-regular);
											color: var(--color-grey);
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											line-height: 16px;
											font-family: var(--font-family-fira);
										}

										.palco-ubicacion-valor{
											font-weight: var(--font-weight-bold);
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											color: var(--color-dark);
											font-family: var(--font-family-poppins);
											text-transform: uppercase;
										}
									}
								}
							}

							.ticket-num{
								font-weight: var(--font-weight-bold);
								font-family: var(--font-family-poppins);
								font-size: 12px;
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								padding: 2px 9px;
								border-radius: 22px;
								background-color: transparent;
								border: 1px solid var(--color-blue);
								color: var(--color-blue);
								letter-spacing: 1px;
								transition: all .2s;
							}
						}
					}

					.disclaimer-ubicacion{
						width: 100%;
						margin: 5px 0px 10px 0px;
						font-size: 12px;
						font-family: var(--font-family-fira);
						font-weight: var(--font-weight-bold);
						line-height: 1.4em;
					}

					.tickets-canjear{
						margin-bottom: 30px;
						@include flex(row, center, center);

						button.btn{
							width: 100%;
							@include flex(row, center, center);
							text-transform: uppercase;
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							position: relative;
							cursor: pointer;
							width: 100%;
							background-color: var(--color-red);
							color: var(--color-white);
							-webkit-transition: background-color .2s ease;
							transition: background-color .2s ease;
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							min-height: 48px;
							padding: 0 24px;
							font-size: 16px;
							line-height: 25px;
							-webkit-font-smoothing: antialiased;
							-moz-osx-font-smoothing: grayscale;
							outline-color: transparent;
							outline: none;
							box-shadow: none;
							border: 0;
							margin: 0;

							&:hover{
								background-color: var(--color-blue-dark);
							}
						}
					}

					.tickets-emitidos{
						margin-top: 30px;

						.tickets-emitidos-title{
							margin: 0;
							font-size: 18px;
							line-height: 26px;
							font-family: var(--font-family-fira);
							font-weight: bold;
							color: var(--color-dark);
						}

						.ticket{
							&:after{
								background-color: var(--color-grey-light);
								color: var(--color-blue-darker);
								height: 100%;
							}

							&:before{
								content: none;
							}

							&:hover{
								&:after{
									background-color: var(--color-grey-light);
									color: var(--color-blue-darker);
								}
							}

							.palco-row{
								@include flex(row, flex-start, center);

								.input-group{
									width: 40%;

									span{
										margin: 0;
										font-size: 16px;
										line-height: 25px;
										font-weight: var(--font-weight-bold);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-dark);
										font-family: var(--font-family-poppins);
										text-transform: uppercase;
										padding-left: 0;
										padding-top: 4px;
										padding-bottom: 5px;
									}
								}

								.descargar-ticket{
									width: 20%;
									@include flex(column, center, center);
									color: var(--color-blue);
									font-size: 13px;
									cursor: pointer;
									line-height: 25px;
									font-weight: var(--font-weight-bold);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									font-family: var(--font-family-poppins);
									text-transform: uppercase;
									text-decoration: none;
									transition: all .2s;

									svg{
										height: auto;
										width: 18px;
										margin-bottom: 4px;
									}

									&:hover{
										opacity: 0.8;
									}
								}

								.generando-ticket{
									width: 20%;
									@include flex(column, center, center);
									color: var(--color-grey);
									font-size: 12px;
									line-height: 18px;
									font-weight: var(--font-weight-regular);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									font-family: var(--font-family-fira);
									text-decoration: none;
									text-align: center;
									transition: all .2s;

									svg{
										height: auto;
										width: 24px;
										margin-bottom: 6px;
										-webkit-animation: rotating 2s linear infinite;
										-moz-animation: rotating 2s linear infinite;
										-ms-animation: rotating 2s linear infinite;
										-o-animation: rotating 2s linear infinite;
										animation: rotating 2s linear infinite;
									}
								}

								.palco-ubicacion{
									padding-top: 10px;
									border-top: 1px solid var(--color-grey-light);
									width: 100%;
								}
							}
						}
					}

					.parking-card{
						width: 100%;
						@include flex(column, flex-start, flex-start);
						background-color: var(--color-white);
						padding: 20px;
						margin: 20px 0px;
						position: relative;
						overflow: hidden;
						min-height: 140px;
						box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.1);

						.parking-card-top{
							@include flex(row, flex-start, center);
							width: 100%;

							// &:before{
							// 	content: '';
							// 	position: absolute;
							// 	width: 60px;
							// 	height: 60px;
							// 	background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Mi41NTA5IDM4LjI5NTkiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDpyZ2IoMCwgNzAsIDE3MywgMC4zNSk7fTwvc3R5bGU+PC9kZWZzPjxnIGlkPSJDYXBhXzIiIGRhdGEtbmFtZT0iQ2FwYSAyIj48ZyBpZD0iQ2FwYV8xLTIiIGRhdGEtbmFtZT0iQ2FwYSAxIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0zOS45MzgzLDEzLjA5NzJsLTIuOTEtOC43MzM2QTYuMzcyLDYuMzcyLDAsMCwwLDMwLjk3NSwwSDExLjU3NkE2LjM3MjEsNi4zNzIxLDAsMCwwLDUuNTIzMSw0LjM2MzZMMi42MTI2LDEzLjA5NzJBNC4yNjE1LDQuMjYxNSwwLDAsMCwwLDE3LjAyVjI3LjY1ODFhNC4yNCw0LjI0LDAsMCwwLDIuMjEwNSwzLjcwODMsMi4xMTQxLDIuMTE0MSwwLDAsMC0uMDgzLjQxNDl2NC4zODdhMi4xMjc3LDIuMTI3NywwLDAsMCwyLjEyNzYsMi4xMjc2SDYuMzgyNkEyLjEyNzYsMi4xMjc2LDAsMCwwLDguNTEsMzYuMTY4M1YzMS45MTMySDM0LjA0MDh2NC4yNTUxYTIuMTI3NiwyLjEyNzYsMCwwLDAsMi4xMjc1LDIuMTI3NmgyLjEyNzZhMi4xMjc2LDIuMTI3NiwwLDAsMCwyLjEyNzUtMi4xMjc2di00LjM4N2EyLjA3NTQsMi4wNzU0LDAsMCwwLS4wODMtLjQxNDksNC4yNCw0LjI0LDAsMCwwLDIuMjEtMy43MDgzVjE3LjAyQTQuMjYyLDQuMjYyLDAsMCwwLDM5LjkzODMsMTMuMDk3MlpNNC4yNTUxLDI3LjY1ODFWMTcuMDJIMzguMjk1OUwzOC4zLDI3LjY1ODFaTTExLjU3Niw0LjI1NTFIMzAuOTcyOEEyLjEyMjksMi4xMjI5LDAsMCwxLDMyLjk5MTksNS43MWwyLjM1Myw3LjA1NUg3LjIwNkw5LjU1NjksNS43MUEyLjEyNzUsMi4xMjc1LDAsMCwxLDExLjU3Niw0LjI1NTFaIi8+PGNpcmNsZSBjbGFzcz0iY2xzLTEiIGN4PSI5LjU3NCIgY3k9IjIyLjMzOTIiIHI9IjMuMTkxMyIvPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMzIuOTc3IiBjeT0iMjIuMzM5MiIgcj0iMy4xOTEzIi8+PC9nPjwvZz48L3N2Zz4=");
							// 	background-position: center;
							// 	background-repeat: no-repeat;
							// 	background-size: 100% auto;
							// 	left: -8px;
							// 	bottom: 10px;
							// 	z-index: 1;
							// }

							&:after{
								content: '';
								position: absolute;
								width: 110px;
								height: 110px;
								background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3OS4xMDcgNzkuMTA3Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzAwNDZBRDt9LmNscy0ye2ZpbGw6bm9uZTtzdHJva2U6IzAwNDZBRDtzdHJva2UtbWl0ZXJsaW1pdDoxMDtzdHJva2Utd2lkdGg6NnB4O308L3N0eWxlPjwvZGVmcz48ZyBpZD0iQ2FwYV8yIiBkYXRhLW5hbWU9IkNhcGEgMiI+PGcgaWQ9IkNhcGFfMS0yIiBkYXRhLW5hbWU9IkNhcGEgMSI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNDQuNzU2NywyMi4wNzE0SDI4LjI0NThWNTcuMDM1Nmg3Ljc3VjQ3LjMyMzNoOC43NDExYTEyLjYyNiwxMi42MjYsMCwwLDAsMC0yNS4yNTE5Wm0wLDE3LjQ4MjFIMzYuMDE1NlYyOS44NDEyaDguNzQxMWE0Ljg1NjIsNC44NTYyLDAsMCwxLDAsOS43MTIzWiIvPjxjaXJjbGUgY2xhc3M9ImNscy0yIiBjeD0iMzkuNTUzNSIgY3k9IjM5LjU1MzUiIHI9IjM2LjU1MzUiLz48L2c+PC9nPjwvc3ZnPg==");
								background-position: center;
								background-repeat: no-repeat;
								background-size: cover;
								right: -22px;
								bottom: -20px;
								z-index: 1;
							}

							.parking-card-left{
								@include flex(row, flex-start, center);
								z-index: 2;

								.parking-numero{
									color: var(--color-red);
									font-weight: var(--font-weight-bold);
									text-transform: uppercase;
									font-family: var(--font-family-poppins);
									font-size: 32px;
								}
							}

							.parking-text{
								margin-left: 30px;
								margin-right: 30px;
								@include flex(row, flex-start, center);
								width: 100%;
								font-family: var(--font-family-poppins);
								font-size: 14px;
								color: var(--color-blue);
								font-weight: var(--font-weight-bold);
							}
						}

						.parking-card-main{
							@include flex(row, space-between, center);
							flex-wrap: wrap;
							width: calc(100% - 90px);

							.parking-input{
								width: calc(50% - 10px);
								margin-top: 20px;
								@include flex(column, center, flex-start);

								label{
									font-size: 16px;
									font-weight: var(--font-weight-regular);
									color: var(--color-grey);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									line-height: 19px;
									font-family: var(--font-family-fira);
								}

								input{
									font-size: 16px;
									line-height: 25px;
									padding-top: 8px;
									border-bottom: 1px solid var(--color-grey-light);
									display: block;
									width: 100%;
									font-weight: var(--font-weight-bold);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									color: var(--color-dark);
									font-family: var(--font-family-poppins);
									text-transform: uppercase;
									padding-top: 8px;
									padding-bottom: 10px;

									&:focus{
										border-color: var(--color-blue);
									}
								}
							}
						}
					}

					.parking-card-ticket{
						width: 100%;
						@include flex(row, flex-start, center);
						background-color: var(--color-blue);
						padding: 20px;
						margin: 20px 0px;
						position: relative;
						overflow: hidden;
						min-height: 140px;
						box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.1);

						.ticket-descargar{
							position: absolute;
							right: 100px;
							top: 50%;
							transform: translateY(-50%);
							@include flex(column, center, center);
							color: var(--color-white);
							font-size: 13px;
							cursor: pointer;
							line-height: 25px;
							font-weight: var(--font-weight-bold);
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							font-family: var(--font-family-poppins);
							text-transform: uppercase;
							text-decoration: none;
							transition: all .2s;

							svg{
								height: auto;
								width: 20px;
								margin-bottom: 4px;
							}

							&:hover{
								opacity: 0.8;
							}
						}

						&:before{
							content: '';
							position: absolute;
							width: 60px;
							height: 60px;
							background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Mi41NTA5IDM4LjI5NTkiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZDgxYTQ4O308L3N0eWxlPjwvZGVmcz48ZyBpZD0iQ2FwYV8yIiBkYXRhLW5hbWU9IkNhcGEgMiI+PGcgaWQ9IkNhcGFfMS0yIiBkYXRhLW5hbWU9IkNhcGEgMSI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMzkuOTM4MywxMy4wOTcybC0yLjkxLTguNzMzNkE2LjM3Miw2LjM3MiwwLDAsMCwzMC45NzUsMEgxMS41NzZBNi4zNzIxLDYuMzcyMSwwLDAsMCw1LjUyMzEsNC4zNjM2TDIuNjEyNiwxMy4wOTcyQTQuMjYxNSw0LjI2MTUsMCwwLDAsMCwxNy4wMlYyNy42NTgxYTQuMjQsNC4yNCwwLDAsMCwyLjIxMDUsMy43MDgzLDIuMTE0MSwyLjExNDEsMCwwLDAtLjA4My40MTQ5djQuMzg3YTIuMTI3NywyLjEyNzcsMCwwLDAsMi4xMjc2LDIuMTI3Nkg2LjM4MjZBMi4xMjc2LDIuMTI3NiwwLDAsMCw4LjUxLDM2LjE2ODNWMzEuOTEzMkgzNC4wNDA4djQuMjU1MWEyLjEyNzYsMi4xMjc2LDAsMCwwLDIuMTI3NSwyLjEyNzZoMi4xMjc2YTIuMTI3NiwyLjEyNzYsMCwwLDAsMi4xMjc1LTIuMTI3NnYtNC4zODdhMi4wNzU0LDIuMDc1NCwwLDAsMC0uMDgzLS40MTQ5LDQuMjQsNC4yNCwwLDAsMCwyLjIxLTMuNzA4M1YxNy4wMkE0LjI2Miw0LjI2MiwwLDAsMCwzOS45MzgzLDEzLjA5NzJaTTQuMjU1MSwyNy42NTgxVjE3LjAySDM4LjI5NTlMMzguMywyNy42NTgxWk0xMS41NzYsNC4yNTUxSDMwLjk3MjhBMi4xMjI5LDIuMTIyOSwwLDAsMSwzMi45OTE5LDUuNzFsMi4zNTMsNy4wNTVINy4yMDZMOS41NTY5LDUuNzFBMi4xMjc1LDIuMTI3NSwwLDAsMSwxMS41NzYsNC4yNTUxWiIvPjxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iOS41NzQiIGN5PSIyMi4zMzkyIiByPSIzLjE5MTMiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMSIgY3g9IjMyLjk3NyIgY3k9IjIyLjMzOTIiIHI9IjMuMTkxMyIvPjwvZz48L2c+PC9zdmc+");
							background-position: center;
							background-repeat: no-repeat;
							background-size: 100% auto;
							left: -12px;
							bottom: 10px;
							z-index: 1;
						}

						&:after{
							content: '';
							position: absolute;
							width: 110px;
							height: 110px;
							background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3OS4xMDcgNzkuMTA3Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0ye2ZpbGw6bm9uZTtzdHJva2U6I2ZmZjtzdHJva2UtbWl0ZXJsaW1pdDoxMDtzdHJva2Utd2lkdGg6NnB4O308L3N0eWxlPjwvZGVmcz48ZyBpZD0iQ2FwYV8yIiBkYXRhLW5hbWU9IkNhcGEgMiI+PGcgaWQ9IkNhcGFfMS0yIiBkYXRhLW5hbWU9IkNhcGEgMSI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNDQuNzU2NywyMi4wNzE0SDI4LjI0NThWNTcuMDM1Nmg3Ljc3VjQ3LjMyMzNoOC43NDExYTEyLjYyNiwxMi42MjYsMCwwLDAsMC0yNS4yNTE5Wm0wLDE3LjQ4MjFIMzYuMDE1NlYyOS44NDEyaDguNzQxMWE0Ljg1NjIsNC44NTYyLDAsMCwxLDAsOS43MTIzWiIvPjxjaXJjbGUgY2xhc3M9ImNscy0yIiBjeD0iMzkuNTUzNSIgY3k9IjM5LjU1MzUiIHI9IjM2LjU1MzUiLz48L2c+PC9nPjwvc3ZnPg==");
							background-position: center;
							background-repeat: no-repeat;
							background-size: cover;
							right: -22px;
							bottom: -20px;
							z-index: 1;
						}

						.parking-card-left{
							@include flex(row, flex-start, center);
							z-index: 2;

							.parking-numero{
								color: var(--color-white);
								font-weight: var(--font-weight-bold);
								text-transform: uppercase;
								font-family: var(--font-family-poppins);
								font-size: 32px;
							}
						}

						.parking-card-right{
							margin-left: 30px;
							@include flex(column, center, flex-start);

							.row{
								width: 100%;
								margin: 10px 0px;
								@include flex(row, flex-start, center);
							}

							.ticket-group{
								@include flex(column, center, flex-start);
								flex-wrap: wrap;
								margin-right: 34px;
								min-width: 100px;
								color: var(--color-white);

								span.label{
									font-size: 16px;
									font-weight: var(--font-weight-regular);
									color: var(--color-white);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									line-height: 19px;
									font-family: var(--font-family-fira);
									margin-bottom: 6px;
								}

								span.valor{
									font-size: 17px;
									font-weight: var(--font-weight-bold);
									color: var(--color-white);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									line-height: 19px;
									font-family: var(--font-family-poppins);

									&.matricula{
										text-transform: uppercase;
									}
								}
							}
						}
					}

					.elegir-fecha{
						width: 100%;
						@include flex(row, space-between, flex-end);
						margin: 20px 0px;

						.input-group{
							width: calc(100% - 140px);
							margin-right: 20px;
						}

						label{
							color: var(--color-dark);
							font-family: var(--font-family-fira);
							font-weight: var(--font-weight-regular);
							font-size: 15px;
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							line-height: 24px;
						}

						button{
							width: 120px;
							@include flex(row, center, center);
							text-transform: uppercase;
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							position: relative;
							cursor: pointer;
							background-color: var(--color-red);
							color: var(--color-white);
							-webkit-transition: background-color .2s ease;
							transition: background-color .2s ease;
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							min-height: 42px;
							padding: 0;
							font-size: 13px;
							line-height: 1em;
							-webkit-font-smoothing: antialiased;
							-moz-osx-font-smoothing: grayscale;
							outline-color: transparent;
							outline: none;
							box-shadow: none;
							border: 0;
							margin: 0;

							&:hover{
								background-color: var(--color-blue-dark);
							}
						}
					}
				}
			}
		}
	}

	/* Responsive */
	@media screen and(max-width: 910px){
		.palco-page{
			.palco-header{
				.container{
					.header-row{
						&:last-child{
							margin: 0px;
						}

						.header-tipo{
							span{
								font-size: 10px;
								padding: 2px 6px;
								border-radius: 3px;
							}
						}

						.header-equipos .header-equipo.header-equipo-local span{
							font-size: 24px;
						}

						.header-equipos .header-equipo.header-equipo-local .header-escudo{
							height: 32px;
						}

						.header-equipos .header-equipo.header-equipo-local span.vs{
							font-size: 18px;
							margin-left: 8px;
							margin-top: 3px;
						}

						.header-equipos .header-equipo.header-equipo-visitante .header-escudo{
							height: 28px;
						}

						.header-equipos .header-equipo.header-equipo-visitante span{
							font-size: 20px;
						}
					}
				}
			}

			.palco-main{
				margin: 30px 0;
				.container{
					@include flex(column, flex-start, flex-start);

					.palco-left{
						width: 100%;
					}

					.palco-right{
						margin-top: 30px;
						position: relative;
						top: auto;
						width: 100%;
					}
				}
			}
		}
	}

	@media screen and(max-width: 730px){
		.palco-page{
			.palco-main{
				.container{
					.palco-left{
						.parking-card{
							&:after{
								display: none;
							}

							.parking-card-main{
								@include flex(column, flex-start, flex-start);
								width: 100%;

								.parking-input{
									width: 100%;
									margin-top: 10px;
								}
							}
						}

						.parking-card-ticket{
							&:after{
								display: none;
							}

							.ticket-descargar{
								right: 20px;
							}

							.parking-card-right{
								.row{
									margin: 0px;
									@include flex(column, flex-start, flex-start);
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and(max-width: 600px){
		.palco-page{
			.palco-main{
				.container{
					.palco-left{
						.parking-card{
							box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.15);
							@include flex(column, center, flex-start);

							&:before{
								display: none;
							}

							.parking-card-left{
								margin-bottom: 10px;
								.parking-numero{
									font-size: 24px;
								}
							}

							.parking-text{
								max-width: none;
								text-align: left;
								margin-left: 0px;
								margin-right: 0px;
								margin-bottom: 10px;
								width: 100%;
							}

							.parking-input{
								width: 100%;
							}
						}

						.parking-card-ticket{
							box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.15);
							@include flex(column, center, flex-start);

							&:before{
								left: auto;
								right: -12px;
								bottom: 5px;
								width: 50px;
								height: 50px;
							}

							.parking-card-left{
								margin-bottom: 10px;
								.parking-numero{
									font-size: 24px;
								}
							}

							.parking-card-right{
								margin-left: 0px;
								@include flex(column, center, flex-start);

								.ticket-group{
									margin: 0px;
									margin-bottom: 13px;
									width: 100%;

									span.label{
										margin-bottom: 3px;
									}
								}
							}

							.ticket-descargar{
								top: 30px;
								right: 14px;
								transform: translate(0, 0)
							}
						}
					}
				}
			}
		}
	}

	@media screen and(max-width: 590px){
		.palco-page{
			.palco-main{
				.container{
					.palco-left{
						.tickets{
							.ticket{
								padding-left: 60px;

								.palco-row{
									.input-group{
										label{
											font-size: 14px;
											line-height: 17px;
										}

										input{
											font-size: 14px;
											line-height: 20px;
										}
									}

									.palco-ubicacion{
										.palco-ubicacion-item{
											padding: 4px 10px 4px 0px;

											.palco-ubicacion-title{
												font-size: 13px;
												line-height: 15px;
											}

											.palco-ubicacion-valor{
												font-size: 14px;
												line-height: 1.4em;
											}
										}
									}
								}

								&:after{
									width: 40px;
									height: calc(100% - 40px);
								}

								&:before{
									width: 40px;
									height: 40px;
									font-size: 13px;
								}
							}
						}
						.tickets-canjear button.btn{
							min-height: 40px;
							margin-top: 20px;
							font-size: 14px;
						}
						.tickets-emitidos{
							.ticket{
								&:after{
									background-color: var(--color-grey-light);
									color: var(--color-blue-darker);
									height: 100%;
								}

								&:before{
									content: none;
								}

								&:hover{
									&:after{
										background-color: var(--color-grey-light);
										color: var(--color-blue-darker);
									}
								}

								.palco-row{
									.input-group{
										width: 80%;
										label{
											font-size: 13px;
											line-height: 16px;
										}

										span{
											font-size: 13px;
											line-height: 18px;
										}
									}

									.descargar-ticket, .generando-ticket{
										position: absolute;
										top: 20px;
										right: 20px;
										font-size: 11px;
									}

									.palco-ubicacion{
										.palco-ubicacion-item{
											padding: 3px 10px 3px 0px;

											.palco-ubicacion-title{
												font-size: 12px;
												line-height: 14px;
											}

											.palco-ubicacion-valor{
												font-size: 13px;
												line-height: 1.3em;
											}
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and(max-width: 510px){
		.palco-page{
			.palco-main{
				.container{
					.palco-left{
						.tickets{
							.ticket{
								.palco-row{
									@include flex(column, flex-start, flex-start);

									.input-group{
										width: 100%;
										padding: 0px;
										padding-bottom: 5px;
									}

									.palco-ubicacion{
										flex-wrap: wrap;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and(max-width: 490px){
		.palco-page{
			.palco-header{
				height: 250px;

				.container{
					.header-row{
						&:last-child{
							margin: 0px;
						}

						.header-tipo{
							span{
								font-size: 10px;
								padding: 2px 6px;
								border-radius: 3px;
							}
						}

						.header-equipos .header-equipo.header-equipo-local span{
							font-size: 20px;
						}

						.header-equipos .header-equipo.header-equipo-local .header-escudo{
							height: 30px;
						}

						.header-equipos .header-equipo.header-equipo-local span.vs{
							display: none;
						}

						.header-equipos .header-equipo.header-equipo-visitante .header-escudo{
							height: 26px;
						}

						.header-equipos .header-equipo.header-equipo-visitante span{
							font-size: 20px;
						}
					}
				}
			}
		}
	}

	@-webkit-keyframes rotating {
		from {
			-webkit-transform: rotate(0deg);
			-o-transform: rotate(0deg);
			transform: rotate(0deg);
		}
		to {
			-webkit-transform: rotate(360deg);
			-o-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}
	@keyframes rotating {
		from {
			-ms-transform: rotate(0deg);
			-moz-transform: rotate(0deg);
			-webkit-transform: rotate(0deg);
			-o-transform: rotate(0deg);
			transform: rotate(0deg);
		}
		to {
			-ms-transform: rotate(360deg);
			-moz-transform: rotate(360deg);
			-webkit-transform: rotate(360deg);
			-o-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}
</style>